import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import isFooterFixed from "../../../_selectors/appSelectors/isFooterFixed";
import isFooterCollapsed from "../../../_selectors/appSelectors/isFooterCollapsed";
import isSidebarMinimized from "../../../_selectors/appSelectors/isSidebarMinimized";
import * as appActions from "../../../_actions/appActions";
import * as userActions from "../../../_actions/userActions";

class Footer extends Component {
  render() {
    const {
      isFooterFixed,
      toggleFixedFooter,
      toggleCollapsedFooter,
      isFooterCollapsed,
      minimizeSidebar,
      isSidebarMinimized,
      logOut
    } = this.props;
    let _classNames = ["dev-page-footer", "dev-page-footer-effect"];

    isFooterFixed ? _classNames.push("dev-page-footer-fixed") : null;
    isFooterCollapsed ? _classNames.push("dev-page-footer-collapsed") : null;
    return (
      <div className={_classNames.join(" ")}>
        <ul class="dev-page-footer-controls">
          <li>
            <Link to="/settings" class="tip" title="Settings">
              <i class="fa fa-cogs" />
            </Link>
          </li>
          <li>
            <a
              class="tip"
              href="mailto:support@amst.co.in"
              target="_top"
              title="Contact Us"
            >
              <i class="fa fa-life-ring" />
            </a>
          </li>
          <li>
            <a
              class="tip"
              title="Logoff"
              onClick={() => {
                logOut();
              }}
            >
              <i class="fa fa-power-off" />
            </a>
          </li>

          <li class="pull-right">
            <a
              class="dev-page-sidebar-minimize tip"
              title="Toggle navigation"
              onClick={() => {
                minimizeSidebar(!isSidebarMinimized);
              }}
            >
              <i class="fa fa-outdent" />
            </a>
          </li>
        </ul>

        <ul class="dev-page-footer-controls dev-page-footer-controls-auto pull-right">
          <li>
            <a
              class="dev-page-footer-fix tip"
              title="Fixed footer"
              onClick={() => {
                toggleFixedFooter(!isFooterFixed);
              }}
            >
              <i class="fa fa-thumb-tack" />
            </a>
          </li>
          <li>
            <a
              class="dev-page-footer-collapse dev-page-footer-control-stuck"
              onClick={() => {
                toggleCollapsedFooter(!isFooterCollapsed);
              }}
            >
              <i class="fa fa-dot-circle-o" />
            </a>
          </li>
        </ul>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  isFooterFixed: isFooterFixed(state),
  isFooterCollapsed: isFooterCollapsed(state),
  isSidebarMinimized: isSidebarMinimized(state)
});
const mapDispatchToProps = dispatch => ({
  toggleFixedFooter: toggle => dispatch(appActions.toggleFixedFooter(toggle)),
  toggleCollapsedFooter: toggle =>
    dispatch(appActions.toggleCollapsedFooter(toggle)),
  minimizeSidebar: minimize => dispatch(appActions.minimizeSidebar(minimize)),
  logOut: () => dispatch(userActions.signOut())
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Footer);



// WEBPACK FOOTER //
// ./src/_components/Layout/Footer/index.js